import { SaltWaterDisposalWellBase } from './base/salt-water-disposal-well-base';

export class SaltWaterDisposalWell extends SaltWaterDisposalWellBase { }